import { getArrayFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { getFiscalYearsForEndpoint, IFiscalYear } from "./storeRequests";
import { APIAnomalyError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../UserContext";

export async function getFiscalYears(getTokenFn: IUserProviderState["accessToken"]): Promise<IFiscalYear[]> {
  const fiscalYears = await getArrayFromCacheOrFromEndpoint<IFiscalYear[]>(
    "FiscalYears",
    getFiscalYearsForEndpoint,
    getTokenFn
  );
  return fiscalYears;
}

export async function fetchAndParseFiscalYears(getTokenFn: IUserProviderState["accessToken"]): Promise<string[]> {
  const fiscalYearList = await getFiscalYears(getTokenFn);
  if (fiscalYearList.length === 0) {
    throw new APIAnomalyError("Received empty Array for Fiscal Years");
  }
  const currentYear: number = new Date().getFullYear();
  const fiscalYears: Set<string> = new Set();
  fiscalYearList.forEach((IfiscalYear) => {
    if (IfiscalYear.fiscalYearNumber >= currentYear && IfiscalYear.fiscalYearNumber <= currentYear + 11)
      fiscalYears.add(IfiscalYear.fiscalYearNumber.toString());
  });
  return Array.from(fiscalYears);
}
